import apiRequest from "./apiConfig";
import { endpoints, apiVersion } from "./endpoints";

export function ambulanceEmployeeMappingApi(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulanceEmployeeMapping + endpoints.ambulanceEmployeeMappingAssign + "?" +query,
    method: 'post'
  })
}

export function ambulanceParkingbayMapping(query) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulanceParkingbayMapping,
    method: 'post',
    query
  })
}

export function getAmbulanceByParkingBay(id) {
  return apiRequest({
    url: process.env.REACT_APP_API_BASE_URL + apiVersion.version + endpoints.ambulanceParkingbayMapping + `/${id}`,
    method: 'get',
  })
}